<template>
    <div class="wa-chat-area" :class="{ 'wa-chat-area--mobile': mobileMode }">
        <!-- Chat header -->
        <WAChatHeader
            :contact="contact"
            :channel="channel"
            :mobile-mode="mobileMode"
            @back="$emit('back')"
            @open-template="openTemplate"
            @close-conversation="closeConversation"
            @view-contact="viewContactProfile"
        />

        <!-- Main content: chat window -->
        <div class="wa-chat-area__body">
            <div class="wa-chat-area__chat">
                <ChatWindow
                    ref="chatWindow"
                    :key="contact._id"
                    :contact="contact"
                    :show-header="false"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { sendSocketMessage } from "../../../../utils/socketStream";
import WAChatHeader from "./WAChatHeader.vue";
import ChatWindow from "../../../../components/popup-chat/chat-window/ChatWindow.vue";

export default {
    name: "WAChatArea",
    components: {
        WAChatHeader,
        ChatWindow,
    },
    props: {
        contact: {
            type: Object,
            required: true,
        },
        channel: {
            type: Object,
            default: null,
        },
        mobileMode: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
        }),
        viewContactProfile() {
            this.addNewWindow({
                type: "show-visitor",
                title: this.contact.fullname || this.contact.name || "Ziyaretçi",
                payload: { visitorId: this.contact._id },
                footer: false,
            });
        },
        openTemplate() {
            const chatWindow = this.$refs.chatWindow;
            if (!chatWindow || !chatWindow.$refs.chat) return;
            const chat = chatWindow.$refs.chat;
            if (!chat || !chat.$refs.messageArea) return;
            const messageArea = chat.$refs.messageArea;
            if (!messageArea || !messageArea.$refs.messageArea) return;
            const area = messageArea.$refs.messageArea;
            if (area && area.triggerTemplateMessage) {
                area.triggerTemplateMessage();
            }
        },
        closeConversation() {
            if (!this.contact || !this.contact.lastConversation) return;
            sendSocketMessage("user close-conversation", { conversationId: this.contact.lastConversation._id });
        },
    },
};
</script>

<style lang="scss" scoped>
// WhatsApp pattern (ikonsuz tile benzeri, subtly outlined shapes)
$wa-bg-color: #efeae2;

.wa-chat-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    background-color: $wa-bg-color;
    position: relative;

    &--mobile {
        width: 100%;
        height: 100%;
    }

    &__body {
        flex: 1;
        display: flex;
        overflow: hidden;
        position: relative;
    }

    &__chat {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-width: 0;
        overflow: hidden;
        // WhatsApp background tile
        background-color: $wa-bg-color;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'%3E%3Cg fill='none' stroke='%23b2bec3' stroke-width='1' stroke-opacity='0.35'%3E%3Ccircle cx='20' cy='20' r='6'/%3E%3Crect x='70' y='12' width='14' height='14' rx='3'/%3E%3Cpath d='M140 14a7 7 0 110 14 7 7 0 010-14zm0 2a5 5 0 100 10 5 5 0 000-10z'/%3E%3Cpath d='M12 70l8-8 8 8-8 8z'/%3E%3Ccircle cx='100' cy='100' r='8'/%3E%3Crect x='150' y='65' width='16' height='16' rx='4'/%3E%3Cpath d='M20 145a8 8 0 110 16 8 8 0 010-16zm0 2a6 6 0 100 12 6 6 0 000-12zM65 170l6-10 6 10z'/%3E%3Ccircle cx='165' cy='155' r='5'/%3E%3Cpath d='M95 160a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7z'/%3E%3C/g%3E%3C/svg%3E");
        background-size: 200px 200px;
        background-repeat: repeat;

        // ChatWindow and Chat.vue içindeki DOM'ları transparan yap
        ::v-deep #chat-window-wrapper {
            background: transparent !important;
            height: 100%;
        }

        ::v-deep #chat-wrapper {
            height: 100%;
            display: flex;
            flex-direction: column;
            background: transparent !important;
        }

        // chat-messages wrapper (ChatMessageList'in root div'ı)
        ::v-deep #chat-messages {
            flex: 1;
            overflow: hidden;
            background: transparent !important;
        }

        // MessageList - inline style'ı !important ile ezmek gerekiyor
        ::v-deep .sc-message-list {
            background-color: transparent !important;
        }

        // Gönderilen mesaj balonu
        ::v-deep .sc-message--right .sc-message--content {
            background: #d9fdd3 !important;
            border-radius: 7.5px 0 7.5px 7.5px !important;
            box-shadow: 0 1px 1px rgba(0,0,0,0.08);
        }

        // Alınan mesaj balonu
        ::v-deep .sc-message--left .sc-message--content {
            background: #fff !important;
            border-radius: 0 7.5px 7.5px 7.5px !important;
            box-shadow: 0 1px 1px rgba(0,0,0,0.08);
        }

        // Mesaj giriş alanı
        ::v-deep #chat-message-area {
            background: #f0f2f5 !important;
            border-top: 1px solid rgba(0,0,0,0.08);
        }
    }
}
</style>
